<template>
    <div>
        <div>
            <div>
                <el-table
                    :data="applyList"
                    stripe
                    style="width: 100%">
                    <el-table-column
                    type="index"
                   >
                    </el-table-column>
                    <el-table-column
                    prop="reason"
                    label="缘由"
                    width="180">
                    </el-table-column>
                    <el-table-column
                        label="权限名"
                        width="180">
                        <template slot-scope="scope">
                            <el-tag>{{ scope.row.authTypeName }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="dealStatusName"
                    label="状态">
                    </el-table-column>
                </el-table>
            </div>
            <div id="post-module" class="post-module">
                <div v-if="applyList.length == 0">
                    <div class="post-moudle__release">
                        <div class="empty-data">暂无数据</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'UserDetailPermission',
    props:{
        serveHost: String
    },
    data() {
        return {
            pagNo:1,
            showApplyPost:0,
            applyList:[],
            user:{}
        }
    },
    methods: {
        
    },
    created() {
        var _vm = this;
        this.user = JSON.parse(localStorage.user);
        $.ajax({
            type:'GET',
            url: _vm.serveHost + "/api/v1/user/apply/" + _vm.user.userid + "/" + _vm.pagNo,
            headers:{
                Authorization:localStorage.getItem('token')
            },
            success: function (res) {
                if(res.data) {
                    _vm.applyList = res.data;
                }
            }
        });
    }
}
</script>

<style scoped>
.empty-data {
    margin: 0 auto;
    padding: 50px;
    color: rgba(0,0,0,.32);
    font-size: 14px;
    line-height: 22px;
    text-align: center;
}
</style>